import type { ReactNode } from 'react'
import { SidePanel } from '@/components/carbon/SidePanel'

interface AdminDrawerProps {
  isOpen: boolean
  onClose: () => void
  title: string
  subtitle?: string
  children: ReactNode
}

/**
 * Right-side drawer for the /admin portal, on the Carbon SidePanel: layer-01,
 * a pinned header (the entity name, its kind and id as the subtitle, Close),
 * a body that scrolls under it, 480px wide and full screen below 672px.
 *
 * The open state is the URL's `drawer=` param (useAdminPortalState); the tabs
 * clear it in `onClose`. The bodies (OrgDrawerContent, PersonDrawerContent,
 * TenantDrawerContent) mount their own modals inside the panel, so headless
 * UI treats them as nested dialogs and a click in one never closes the drawer.
 */
export default function AdminDrawer({ isOpen, onClose, title, subtitle, children }: AdminDrawerProps) {
  return (
    <SidePanel open={isOpen} onClose={onClose} title={title} subtitle={subtitle}>
      {children}
    </SidePanel>
  )
}
